(() => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return;
  }

  function select(element) {
    let selectedText;

    if (element.nodeName === 'SELECT') {
      element.focus();

      selectedText = element.value;
    } else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
      const isReadOnly = element.hasAttribute('readonly');

      if (!isReadOnly) {
        element.setAttribute('readonly', '');
      }

      element.select();
      element.setSelectionRange(0, element.value.length);

      if (!isReadOnly) {
        element.removeAttribute('readonly');
      }

      selectedText = element.value;
    } else {
      if (element.hasAttribute('contenteditable')) {
        element.focus();
      }

      const selection = window.getSelection();
      const range = document.createRange();

      range.selectNodeContents(element);
      selection.removeAllRanges();
      selection.addRange(range);

      selectedText = selection.toString();
    }

    return selectedText;
  }

  function copy(text, showNotification = true) {
    const element = document.createElement('textarea');
    const previouslyFocusedElement = document.activeElement;
    const yPosition = (document.scrollingElement || document.body).scrollTop;

    Object.assign(element.style, {
      position: 'absolute',
      top: `${yPosition}px`,
      left: '-9999px',
      margin: '0',
      padding: '0',
      border: '0',
      fontSize: '12pt',
      visibility: 'hidden',
    });

    element.setAttribute('readonly', '');
    element.value = text;

    document.querySelector('body').appendChild(element);

    select(element);
    document.execCommand('copy');
    document.querySelector('body').removeChild(element);
    previouslyFocusedElement.focus();

    if (showNotification) {
      window.swinger.clipboard.notify(text);
    }
  }

  window.swinger = window.swinger || {};
  window.swinger.clipboard = window.swinger.clipboard || {};
  window.swinger.clipboard.copy = copy;
})();
